import { getResourceFieldOptions } from "src/system/getResourceFieldOptions.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const useResourceFieldOptions = ({
  resource,
  field,
}: {
  resource: string;
  field: string;
}) => {
  const { t } = useTranslation(TranslationNamespaceEnum.Common);
  return getResourceFieldOptions({
    resource,
    field,
    t,
  });
};
